// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1TGnh","kyc-container":"kyc-container__YNTy0","alert-container":"alert-container__164ZA","flex-5":"flex-5__24cxO","order-detail-container":"order-detail-container__3HbMs","processing-order-container":"processing-order-container__3YKVC","img-container":"img-container__2kzyw","fund-image":"fund-image__C-csF","calender":"calender__32F4r","mandate-container":"mandate-container__Vcocp","btn-width":"btn-width__3auzy","mandate-status":"mandate-status__3Eiza"};


//////////////////
// WEBPACK FOOTER
// ./styles/status-page/ProcessingOrderDetails.scss
// module id = 460
// module chunks = 68